export default "__VITE_ASSET__aq9Vj5Qe__"